import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

const CustomIconButton = ({ title, onClick, children, ...props }) => {
  return (
    <Tooltip title={title} arrow classes={{ popper: 'custom-tooltip' }}>
      <span>
        <IconButton onClick={onClick} {...props}>
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default CustomIconButton;
